import configureApp from 'configureApp';

export const baseUrl = `${configureApp.endpoint.clients}/publish/coupons`;

export const clientUrl = `${configureApp.endpoint.clients}/me/coupons`;
